export const DMCA_LINK = 'https://tellus.social/about/support/copyright'
export const SUPPORT_PAGE = 'https://tellus.social/about/support'
